import React from 'react';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { ReviewItem } from '../Review/components/ReviewItem';

export const FundAccountsReview = () => {
  const {
    workflow: {
      data: { fundAccounts },
    },
  } = useCharitableGivingContext();

  return (
    <ReviewItem
      label="Earmarked accounts"
      value={fundAccounts && fundAccounts.length > 0 ? fundAccounts.length : '—'}
    />
  );
};
